module.exports = __webpack_public_path__ + "img/onlineDeclaration.8c492df8.png";